import { of as observableOf, Observable } from "rxjs";

import { catchError } from "rxjs/operators";
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, Router } from "@angular/router";

import { CommunityService } from "../community.service";
import { Community } from "../../../models";

@Injectable()
export class ViewableCommunityResolver implements Resolve<Community> {
  constructor(
    private communityService: CommunityService,
    private router: Router
  ) {}

  public resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.communityService.findOne(route.params["communityName"]).pipe(
      catchError((err) => {
        this.router.navigateByUrl("/error");
        return observableOf(null);
      })
    );
  }
}
